<app-event-history-log
    [events]="events$ | async"
    [loading]="loading$ | async"
    [error]="error$ | async"
    [webhookLookups]="webhookLookups$ | async"
    [sorting]="sorting$ | async"
    (sortingChanged)="onSortingChanged($event)"
    [pager]="pager$ | async"
    (pageChanged)="onPageChanged($event)"
    [filter]="filter$ | async"
    (filterChanged)="onFilterChanged($event)">
</app-event-history-log>
